import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { toCurrencyString } from '@shared-helpers/string-number-helpers';

import { IPerDiemConfigItem } from '../../../scripts/PayrollTimesheet';
import { DatahubService } from '../../../services/datahub.service';

export interface IVerticalBulkAddPerDiemValue extends IPerDiemConfigItem {
  perDiemAmount: string;
}

@Component({
  selector: 'app-modal-content-vertical-bulk-add-per-diem',
  templateUrl: './modal-content-vertical-bulk-add-per-diem.component.html',
  styleUrl: './modal-content-vertical-bulk-add-per-diem.component.css',
  standalone: false,
})
export class ModalContentVerticalBulkAddPerDiemComponent implements OnInit {
  @Input() public employeesCount = 0;
  @Input() public formattedDate = '';
  @Input() public costCenter?: string;
  @Output() public readonly closed = new EventEmitter<IVerticalBulkAddPerDiemValue[] | undefined>();

  public weDate = '';
  public tableValues: IVerticalBulkAddPerDiemValue[] = [];

  public get totalPerDiemAmount(): number {
    return this.tableValues.map((row) => Number(row.perDiemAmount ?? 0)).reduce((prev, curr) => prev + curr, 0);
  }

  constructor(private readonly datahub: DatahubService) {}

  ngOnInit(): void {
    this.weDate = this.datahub.weDate.getHumanReadableDateString();
    this.tableValues = this.datahub.payrollTimesheet.perDiemsConfig.map((config) => ({ ...config, perDiemAmount: '' }));
  }

  public cancel(): void {
    this.closed.emit();
  }

  public confirm(): void {
    this.closed.emit(
      this.tableValues.map((val) => {
        val.perDiemAmount = toCurrencyString(val.perDiemAmount);
        return val;
      }),
    );
  }
}
